import React, { useEffect, useState } from "react";
import style from "./VendorDetails.module.css";
import MenuBar from "./MenuBar";
import axios from "axios";
import { API_BASE_URL } from "./config.js";
import HeadingBar from "./HeadingBar.js";

const VendorDetails = () => {
  const vendordataRaw = sessionStorage.getItem("vendordata");
  const vendorInfo = vendordataRaw ? JSON.parse(vendordataRaw) : null;
  const vendorCode = vendorInfo?.CardCode;
  const isEmbedded = sessionStorage.getItem("mode") === "embedded";
  const [vendorDetails, setVendorDetails] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!vendorCode) {
      setError("Vendor data missing");
      return;
    }

    axios
      .get(`${API_BASE_URL}/VendorDetails?VendorCode=${vendorCode}`)
      .then((res) => {
        if (res.data && res.data.length > 0) {
          setVendorDetails(res.data[0]);
        } else {
          setError("Vendor details not found");
        }
      })
      .catch(() => setError("Failed to fetch vendor details"));
  }, [vendorCode]);

  return (
    <div className={style.VendorDetails}>
      {!isEmbedded && (
        <div className={style.HeadingBarContainer}>
          <HeadingBar />
        </div>
      )}

      <div className={style.VendorDetailsContainer}>
        <div className={style.MenuBarContainer}>
          <MenuBar />
        </div>

        <div className={style.MainVendorDetailsPageContainer}>
          <div className={style.MainArea}>
            <div className={style.MenuNameDetails}>Vendor Details</div>

            {error && <div className={style.error}>{error}</div>}
            {!error && !vendorDetails && <div>Loading...</div>}

            {vendorDetails && (
              <div className={style.cardsdiv}>
                {/* DETAILS */}
                <div className={style.cardcss}>
                  <div className={style.cardTitle}>Details</div>
                  <table className={style.tablevendordetailsone}>
                    <tbody>
                      <tr>
                        <td>Vendor Code</td>
                        <td>{vendorDetails.CardCode}</td>
                      </tr>
                      <tr>
                        <td>Vendor Name</td>
                        <td>{vendorDetails.CardName}</td>
                      </tr>
                      <tr>
                        <td>Contact Person</td>
                        <td>{vendorDetails.CntctName}</td>
                      </tr>
                      <tr>
                        <td>Email</td>
                        <td>{vendorDetails.CntctEmail}</td>
                      </tr>
                      <tr>
                        <td>Mobile</td>
                        <td>{vendorDetails.CntctMob}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* BILLING / SHIPPING */}
                <div className={style.cardcss}>
                  <div className={style.cardTitle}>
                    Billing / Shipping Details
                  </div>
                  <table className={style.tablevendordetailsone}>
                    <tbody>
                      <tr>
                        <td>Billing Address</td>
                        <td>{vendorDetails.BillingAdress}</td>
                      </tr>
                      <tr>
                        <td>Shipping Address</td>
                        <td>{vendorDetails.ShippingAdress}</td>
                      </tr>
                      <tr>
                        <td>GST No</td>
                        <td>{vendorDetails.GSTRegNo}</td>
                      </tr>
                      <tr>
                        <td>GST Type</td>
                        <td>{vendorDetails.GSTType}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>

                {/* BANK */}
                <div className={style.cardcss}>
                  <div className={style.cardTitle}>Bank Details</div>
                  <table className={style.tablevendordetailsone}>
                    <tbody>
                      <tr>
                        <td>Bank Country</td>
                        <td>{vendorDetails.BankCountry}</td>
                      </tr>
                      <tr>
                        <td>Bank Name</td>
                        <td>{vendorDetails.BankCode}</td>
                      </tr>
                      <tr>
                        <td>Account Number</td>
                        <td>{vendorDetails.BankAccountNo}</td>
                      </tr>
                      <tr>
                        <td>IFSC Code</td>
                        <td>{vendorDetails.BankIFSC}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorDetails;
